// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__35I7B","productName":"Table_productName__3lh_P"};